/**
 * Whether this process is running against production. The app and Lambdas
 * set `NEXT_PUBLIC_IS_PRODUCTION`; the AI service sets `IS_PRODUCTION`.
 */
export const IS_PRODUCTION =
  (process.env.NEXT_PUBLIC_IS_PRODUCTION ?? process.env.IS_PRODUCTION) ===
  "true";

/** Mirrors the app's `IS_LOCAL` (`apps/web/src/config.ts`). */
export const IS_LOCAL =
  process.env.NODE_ENV === "development" || process.env.IS_LOCAL === "true";
